import React from 'react';

/**
 * View of the dashboard. Isn't filled with useful information just yet.
 * Can be used in the future to display news or messages to the designer.
*/
const Dashboard = () => {
    const username = sessionStorage.getItem("username")
    return (
        <div>
            <h1>{username !== null ? window.i18n('greeting_short') + username + "!" : window.i18n('greeting_long')}</h1>
            <span>&nbsp;&nbsp;</span>
            <h3>{window.i18n('news') + ":"}</h3>
            <p>{window.i18n('noNews')}</p>
        </div>
    );
}

export { Dashboard }